export default function getClientId() {
    const clientIdStart = document && document.cookie && document.cookie.split('ClientId=')[1];
    return clientIdStart && clientIdStart.split(';')[0];
}
